// Common text for English
const commonTextEn = {
  COMPANY_USER_SETTING: 'User',
  PEOPLE_COUNTS: 'People Counts',
  PEOPLE_COUNTS_ANALYSIS: 'People Counts Analysis',
  EMPLOYEE_LOCATIONS: 'Employee Locations',
  EMPLOYEE_ACCESS_LOG: 'Employee Access Log',
  AIR_QUALITY: '環境 (Environment)',
  MEETING_ROOM_OUTLOOK_BAR: 'Meeting Room Outlook Bar',
  MEETING_ROOM_OUTLOOK_USAGE: 'Meeting Room Outlook Table',
  MEETING_ROOM_OUTLOOK_BOOKING: 'Meeting Room Outlook Booking',
  MEETING_ROOM_OUTLOOK_UNUSED_BOOKING: 'Meeting Room Outlook Unused Booking',
  MEETING_ROOM_USAGE: 'Meeting Room Usage',
  DEVICE_STATUS_OVERVIEW: 'Device Status Overview',
  NETWORK: 'ワイヤレス (Wireless)',
  NETWORK_USAGE: 'Data Rates (Network Usage)',
  NETWORK_CLIENT_COUNT: 'Network Client Count',
  WIRELESS_LATENCY: 'Wireless Latency',
  WIRELESS_CHANNEL_UTILIZATION: 'Wireless Channel Utilization',
  WIRELESS_SIGNAL: 'Signal Quality',
  NETWORK_PERFORMANCE_SCORE: 'Network Performance Score',
  DEVICE_NAME: 'Device Name',
  DEVICE: 'Device',
  MERAKI_DEVICE_NAME: 'Meraki Device Name',
  STATUS: 'Status',
  LAST_UPDATED_TIME: 'Last Updated',
  VACANT: 'Vacant',
  OCCUPIED: 'Occupied',
  EMPLOYEE_NAME: 'Employee Name',
  ROOM_NAME: 'Room',
  DEPARTMENT: 'Department',
  TEAM: 'Team',
  FLOOR_NOT_SELECTED_PLEASE_SELECT:
    'Floor not selected. Please select a floor.',
  TENANT_NOT_SELECTED_PLEASE_SELECT:
    'Tenant not selected. Please select a tenant.',
  BRANCH_NOT_SELECTED_PLEASE_SELECT:
    'Branch not selected. Please select a branch.',
  NO_DATA: 'No Data',
  CANNOT_LOAD_FLOORMAP: 'Could not load floor map',
  LOADING_DATA: 'Loading data...',
  UPDATING_DATA: 'Updating data...',
  TOP_3: 'Top 3',
  TOP_5: 'Top 5',
  TOP_10: 'Top 10',
  TOP_ALL: 'All',
  REFRESH_BUTTON_TEXT: 'Refresh',
  TENANT: 'Tenant',
  BRANCH: 'Branch',
  FLOOR: 'Floor',
  SELECT: 'Select',
  SELECT_TENANT: 'Select Tenant',
  SELECT_BRANCH: 'Select Branch',
  SELECT_FLOOR: 'Select Floor',
  AVERAGE_SCORE: 'Average Score',
  SCORE_TRANSITION: 'Score Transition',
  BACKGROUND: 'Background',
  BEST_EFFORT: 'Best Effort',
  VIDEO: 'Video',
  VOICE: 'Voice',
  SORT_BY_DEVICE_NAME: 'Device Name',
  SORT_BY_PERFORMANCE_SCORE_DESC: 'Performance Score Desc',
  SORT_BY_PERFORMANCE_SCORE_ASC: 'Performance Score Asc',
  RESERVED: 'Reserved',
  RESERVED_AND_UNUSED: 'Reserved & Unused',
  OCCUPIED_9_18: 'Occupied 9h-18h',
  UNUSED_RESERVATION: 'Unused Reservation',
  RESERVATION_COUNTS: 'Reservation Counts',
  EMPTY_BOOKING_RATE: 'Empty Booking Rate',
  MINUTES: 'Minutes',
  PAST_ONE_WEEK: 'Last 1 Week',
  PAST_ONE_MONTH: 'Last 1 Month',
  NAME: 'Name',
  FREE_BOOKING_TIME: 'Free Booking Time',
  CURRENT_RESERVATION: 'Current Reservation',
  NEXT_RESERVATION: 'Next Reservation',
  RESERVATION_TIME_BY_ROOM: 'Reservation Time by Room',
  COLLAPSE_ALL: 'Collapse All',
  NETWORK_CLIENT_COUNT_DESCRIPTION:
    'The number of terminals connected to the access point',
  PERFORMANCE_SCORE_DESCRIPTION:
    'Scores are accumulated for various indicators.',
  PERFORMANCE_SCORE_LEGEND_HEADER: 'Score',
  WIRELESS_SIGNAL_DESCRIPTION:
    'Access point channel and SNR (signal-to-noise ratio)',
  WIRELESS_SIGNAL_LEGEND_HEADER: 'SNR',
  NETWORK_USAGE_DESCRIPTION:
    'Data transfer rate between access point and terminal',
  WIRELESS_CHANNEL_UTILIZATION_DESCRIPTION:
    'The interference level of the channel used by the access point',
  WIRELESS_LATENCY_DESCRIPTION: 'Delay time for each communication type',
  AVERAGE: 'Average',
  CHANGE: 'Change',
  TEMPERATURE: 'Temperature',
  HUMIDITY: 'Humidity',
  CARBON_DIOXIDE: 'Carbon Dioxide',
  NOISE_LEVEL: 'Noise Level',
  LAST_24_HOUR: 'Last 24 Hours',
  LAST_ONE_WEEK: 'Last 1 Week',
  LAST_ONE_MONTH: 'Last 1 Month',
  //CsvExport
  CSV_EXPORT: 'CSV Export',
  OLD_VALUE: 'Old',
  NEW_VALUE: 'New',
  DATA_CONFIGURATION: 'Data Config',
  TK_OVERVIEW: 'Takachiho Trading Overview',
  // Setting
  TENANT_SETTING: 'Tenant',
  ORGANIZATION_SETTING: 'Organization',
  LOCATION_SETTING: 'Location',
  FLOOR_SETTING: 'Floor',
  AREA_SETTING: 'Area',
  VERKADA_DEVICE_SETTING: 'Verkada Device',
  DEVICE_LOCATION_SETTING: 'Device Location',
  COMPANY_EMPLOYEE_SETTING: 'Employee',
  EMPLOYEE_TERMINAL_SETTING: 'Employee Terminal',
  USER_SETTING: 'User',
  WORKING_HOUR_SETTING: 'Working Hour',
  CAMERA_ZONE_SETTING: 'Camera Zone',
  AIR_QUALITY_SETTING: 'Air Quality',
  AUDIT_WRITE_LOG: 'Data Change Logs',
  // End setting

  // Validation
  REQUIRED: 'Required',
  EMPLOYEE_INFORMATION: 'Employee Information',
  EMPLOYEE_NUMBER: 'Employee Number',
  VERKADA_ID: 'Verkada Employee ID',
  EMPLOYEE_IMAGE: 'Image',
  EMPLOYEE_PHONE_NUMBER: 'Phone Number 1',
  EMPLOYEE_PHONE_NUMBER2: 'Phone Number 2',
  EMPLOYEE_EMAIL: 'Email',
  EMPLOYEE_TOOL_CHAT: 'Chat Tool',
  EMPLOYEE_DEVICE_PC_MAC: 'PC - Mac Address',
  EMPLOYEE_DEVICE_PC_NAME: 'PC - Device Name',
  EMPLOYEE_DEVICE_MOBILE_MAC: '携帯 - Mac Address',
  EMPLOYEE_DEVICE_MOBILE_NAME: '携帯 - Device Name',
  EMPLOYEE_NAME_READING: 'Employee Reading Kana',
  EMAIL_FORMAT_ERROR_MESSAGE: 'Invalid email format',
  USER_INFORMATION: 'User Information',
  PASSWORD: 'Password',
  FIRST_NAME: 'First Name',
  LAST_NAME: 'Last Name',
  PHONE: 'Phone',
  PRIVILEGE: 'Role',

  SAVE: 'Save',
  CANCEL: 'Cancel',
  ADD_NEW: 'Add',
  DELETE_CONFIRMATION_HEADER: 'Delete Confirmation',
  DELETE_CONFIRM_MESSAGE: 'Are you sure you want to delete it?',
  DOWNLOAD: 'Download',
  RESONABLE_VALUE: 'Reasonable Value',
  INFO_COPIED_TO_CLIPBOARD: 'Copied to clipboard',
  EMPLOYEE_NO_EVENTS: 'No events',
  NO_LOCATION_DATA: 'No location data',
  DEVICE_LOCATION_CHANGE_HEADER: 'Device Location Change',
  STATUS_NEW: 'New',
  STATUS_MODIFIED: 'Modified',
  STATUS_DELETED: 'Deleted',
  AREA_CAPACITY: 'Area Capacity',
  MOBILE_DEVICE_TYPE: 'Phone',
  PC_DEVICE_TYPE: 'PC',
  AREA_NAME: 'Area Name',
  COUNTS: 'Counts',
  CAPACITY_RATE: 'Capacity Rate',
  NO_CHANGE_TO_BE_SAVED: 'No change to be saved.',
  EMPLOYEE_ATTENDANCE_RATE: 'Employee Attendance Rate',
  SIGNAGE_MODE: 'Signage Mode',
  LATEST_ATTENDANCE_RATE: 'Latest Attendance Rate',
  LOG: 'Log',
  SET: 'Set',
  BY_TIME: 'By Time',
  BY_DAY: 'By Day',
  FROM_DATE: 'From',
  TO_DATE: 'To',
  TYPE: 'Type',
  NO_ZONE: 'No Zone',
  ZONE: 'Zone',
  NO_DEVICE: 'No Device',
  MAKE_RESERVATION: 'Make Reservation',
  ATTENDANCE_RATE: 'Attendance Rate',
  SHOW_CAMERA: 'Show Camera',
  HIDE_CAMERA: 'Hide Camera',
  SHOW_HIDE_CAMERA: 'Show/Hide Device',
  DEVICE_DISPLAY: 'Device Display',
  THRESHOLD_SETTING: 'Threshold Setting',
  PLEASE_INPUT_VALID_NUMBER: 'Please input valid number',
  HIGH: 'High',
  LOW: 'Low',
  INFO: 'Info',
  COMPONENT: 'Component',
  DISPLAY_TIME: 'Display Time',
  CARBON_DIOXIDE_UNIT: 'ppm',
  BUTLR_USERNAME: 'Username',
  BUTLR_API_KEY: 'ApiKey',
  GAROON_USERNAME: 'Username',
  GAROON_API_KEY: 'ApiKey',
  GAROON_SUBDOMAIN: 'Subdomain',
  GOOGLE_API_KEY: 'ApiKey',
  GOOGLE_USERNAME: 'Username',
  WEBEX_API_KEY: 'ApiKey',
  WEBEX_REFRESH_TOKEN: 'RefreshToken',
  WEBEX_CLIENT_ID: 'ClientId',
  WEBEX_CLIENT_SECRET: 'Client Secret',
  MICROSOFT_API_KEY: 'ApiKey',
  MICROSOFT_GRAPH_CLIENT_ID: 'Graph Client Id',
  MICROSOFT_GRAPH_TENANT_ID: 'Graph Tenant Id',
  API_KEY: 'ApiKey',
  SCHEDULE_TOOL: 'Schedule Tool',
  SHORTENING_MEETING: 'Shortening Meeting',
  ROOM_NOTICE: 'Meeting room shortening/cancellation notice',
  MEETING_ROOM_ANALYSIS_SETTING: 'Meeting Room Usage Analysis',
  ANALYSIS_TIME_SETTINGS: 'Analysis Time Settings',
  ANALYSIS_TIME_SETTINGS_TOOLTIP: 'Calculate meeting room reservation rate and usage based on this time period.',
  MEETING_ROOM_SHORTENING_CANCEL: 'Meeting Room Shortening/Cancel',
  ACTIVE_TIME_SETTINGS: 'Active Time Settings',
  ACTIVE_TIME_SETTINGS_TOOLTIP: 'Set the time range for enabling shortening/cancel notifications for each day of the week.',
  DEVICE_ACTIVE_TIME_SETTINGS_TOOLTIP: 'Set the time range to enable shortened/cancellation notifications for each day of the week. This setting takes precedence over the one configured in \'Meeting Room Usage Analysis.\'',
  DISABLED: 'Disabled',
  ENABLED: 'Enabled',
  ACTIVE: 'Active',
  SLEEP: 'Sleep',
  START_TIME: 'Start',
  END_TIME: 'End',
  MONDAY: 'Monday',
  TUESDAY: 'Tuesday',
  WEDNESDAY: 'Wednesday',
  THURSDAY: 'Thursday',
  FRIDAY: 'Friday',
  SATURDAY: 'Saturday',
  SUNDAY: 'Sunday',
  PEOPLE_COUNTS_LEGEND: 'Legend',
  ATTENDANCE_RATE_THRESHOLD: 'Attendance Rate Threshold',
  NO_DEVICE_AVAILABLE: 'No Device Available',
  START_SIGNAGE_MODE: 'Start signage mode',
  PRESS_ESC_TO_EXIT: 'Press esc to exit',
  LAST_UPDATE_TS: 'Last updated',
  UPLOAD_MESSAGE: 'Upload Message',
  UPLOAD_MESSAGE_SUCCESS: 'Upload successfully',
  UPLOAD_ERROR_MESSAGE: 'Upload Error',
  UPLOAD_EXCEED_MESSAGE: 'File size exceeds the limit of 1MB',
  UPLOAD_FAILED_MESSAGE: 'Upload file failed',
  UPLOAD_MULTIPLE_ERROR_MESSAGE: 'Cannot upload multiple files at once',
  EMPLOYEE_LOCATIONS_LIST: 'Map',
  EMPLOYEE_LOCATIONS_MAP: 'List',
  OTHER_GROUP: 'Other',
  EMPLOYEE_LOCATION_SELECT: 'Select your department/team',
  BCP: 'BCP',
  EMPLOYEE_BCP_SELECT: 'Select your floor',
  CAPACITY: 'Capacity',
  ADD_MULTIPLE_BRANCH_ERROR_MESSAGE: 'Cannot add more branch',
  ADD_MULTIPLE_FLOOR_ERROR_MESSAGE: 'Cannot add more floor',
  ADD_MULTIPLE_DEPARTMENT_ERROR_MESSAGE: 'Cannot add more department',
  TENANT_SIGN_ON: 'Single sign-on',
  TENANT_AUTH_PROVIDER: 'Authentication provider',
  TENANT_AZURE_TENANT_ID: 'Tenant ID',
  TENANT_AZURE_CLIENT_ID: 'Application (client) ID',
  TENANT_AZURE_CLIENT_SECRET: 'Client secret',
  WEBHOOK_URL: 'Webhook URL',
  TOKEN: 'Token',
  PEOPLE_COUNT_SELECTED: 'Values displayed on the map',
  RATE: 'Rate',
  THRESHOLD: 'Threshold',
  DEVICE_LOCATION_SHORTENING_METHOD: 'Shortening meetings that end early',
  DEVICE_LOCATION_SHORTENING_THRESHOLD_1: 'From termination to shortening',
  DEVICE_LOCATION_SHORTENING_THRESHOLD_1_REPLY:
    'From termination to notification',
  DEVICE_LOCATION_SHORTENING_THRESHOLD_2: 'From notification to shortening',
  DEVICE_LOCATION_CANCEL_METHOD: 'Cancel a meeting that does not start',
  DEVICE_LOCATION_CANCEL_THRESHOLD_1: 'From start time to cancellation',
  DEVICE_LOCATION_CANCEL_THRESHOLD_1_REPLY: 'From start time to notification',
  DEVICE_LOCATION_CANCEL_THRESHOLD_2: 'From notification to cancellation',
  DEVICE_LOCATION_SHORTENING_METHOD_DISABLED: 'Disabled',
  DEVICE_LOCATION_SHORTENING_METHOD_SILENCE: 'Automatically shorten',
  DEVICE_LOCATION_SHORTENING_METHOD_REPLY_SHORTENING:
    'Shorten after replying to notification',
  DEVICE_LOCATION_SHORTENING_METHOD_REPLY_KEEP:
    'Keep after replying to notification',
  DEVICE_LOCATION_CANCEL_METHOD_DISABLED: 'Disabled',
  DEVICE_LOCATION_CANCEL_METHOD_SILENCE: 'Automatically cancel',
  DEVICE_LOCATION_CANCEL_METHOD_REPLY_CANCEL:
    'Cancel after replying to notification',
  DEVICE_LOCATION_CANCEL_METHOD_REPLY_KEEP:
    'Keep after replying to notification',
  ARUBA_API_KEY: 'ApiKey',
  ARUBA_REFRESH_TOKEN: 'Refresh Token',
  ARUBA_CLIENT_SECRET: 'Client Secret',
  ARUBA_CLIENT_ID: 'ClientId',
  TITLE_NOTICE: 'Notice',
  INPUT_NOTICE_ERROR_MESSAGE: 'Please enter no more than 3 lines of notice.',
  BRANCH_SETTING_HEADER1: 'Display Order',
  BRANCH_SETTING_HEADER2: 'Location Name',
  BRANCH_SETTING_HEADER3: 'Meraki Network/Aruba Site',
  FLOOR_SETTING_HEADER1: 'Branch Name',
  FLOOR_SETTING_HEADER2: 'Display Order',
  FLOOR_SETTING_HEADER3: 'Floor Name',
  FLOOR_SETTING_HEADER4: 'Meraki/Aruba Floor',
  FLOOR_SETTING_HEADER5: 'Floor Map',
  EMPTY: 'Empty',
  CROWDED: 'Crowded',

  // Workflows Changelog
  AUDIT_WRITE_LOG_TIMESTAMP: 'Timestamp',
  AUDIT_WRITE_LOG_ACTOR: 'Actor',
  AUDIT_WRITE_LOG_URL: 'URL',
  AUDIT_WRITE_LOG_CONTENT: 'Content',
  AUDIT_WRITE_LOG_HTTP_METHOD: 'HTTP Method',

  // New constants for success/error messages
  SAVED_SUCCESSFULLY: 'Saved successfully',
  SAVE_FAILED: 'Failed to save changes',
  EMAIL_ALREADY_EXISTS: 'Email already exists',
  UNEXPECTED_ERROR: 'An unexpected error occurred',

  // IP Restriction error messages
  IP_RESTRICTION_ERROR_TITLE: 'Access Denied',
  IP_RESTRICTION_ERROR_MESSAGE: 'Access from this IP address is not allowed.',
  IP_RESTRICTION_SOURCE_IP: 'Source IP Address',

  // Employee Follow Feature
  FOLLOW: 'Follow',
  UNFOLLOW: 'Unfollow',
  FOLLOWING: 'Following',
  FOLLOW_ALL: 'Follow All',
  UNFOLLOW_ALL: 'Unfollow All',
  FOLLOWED_SUCCESS: 'Followed',
  UNFOLLOWED_SUCCESS: 'Unfollowed',
  FOLLOWERS_ONLY: 'Followers',
  FOLLOW_SECTION_TITLE: 'Follow',
  NO_FOLLOWED_EMPLOYEES: 'No followed employees',
  NO_USER_FOUND: 'No user found',
};

// Common text for Japanese
const commonTextJp = {
  COMPANY_USER_SETTING: 'ユーザー',
  PEOPLE_COUNTS: '人数検知',
  PEOPLE_COUNTS_ANALYSIS: '人数検知分析',
  EMPLOYEE_LOCATIONS: '社員の所在',
  EMPLOYEE_ACCESS_LOG: '従業員ログ管理',
  AIR_QUALITY: '環境',
  MEETING_ROOM_OUTLOOK_BAR: '会議室 予約状況',
  MEETING_ROOM_OUTLOOK_USAGE: '会議室 利用分析',
  MEETING_ROOM_OUTLOOK_BOOKING: '予約時間',
  MEETING_ROOM_OUTLOOK_UNUSED_BOOKING: '空予約時間',
  MEETING_ROOM_USAGE: '会議室 利用状況',
  DEVICE_STATUS_OVERVIEW: 'デバイスステータス',
  NETWORK: 'ワイヤレス',
  NETWORK_USAGE: 'データレート', // English text is used as fallback
  NETWORK_CLIENT_COUNT: '接続端末数',
  WIRELESS_LATENCY: '遅延', // English text is used as fallback
  WIRELESS_CHANNEL_UTILIZATION: 'チャネル利用率', // English text is used as fallback
  WIRELESS_SIGNAL: '信号品質',
  NETWORK_PERFORMANCE_SCORE: 'パフォーマンススコア', // English text is used as fallback
  DEVICE_NAME: 'デバイス名',
  DEVICE: 'デバイス',
  MERAKI_DEVICE_NAME: '接続先',
  STATUS: 'ステータス',
  LAST_UPDATED_TIME: '更新日時',
  VACANT: '空室',
  OCCUPIED: '在室',
  EMPLOYEE_NAME: '社員名',
  ROOM_NAME: '部屋名',
  DEPARTMENT: '部署',
  TEAM: 'チーム',
  FLOOR_NOT_SELECTED_PLEASE_SELECT:
    'フロアが選択されていません。フロアを選択してください。',
  TENANT_NOT_SELECTED_PLEASE_SELECT:
    'テナントが選択されていません。テナントを選択してください。',
  BRANCH_NOT_SELECTED_PLEASE_SELECT:
    '拠点が選択されていません。拠点を選択してください。',
  NO_DATA: 'データなし',
  CANNOT_LOAD_FLOORMAP: 'フロアマップを読み込めませんでした',
  LOADING_DATA: 'データ読込中...',
  UPDATING_DATA: '更新中...',
  TOP_3: 'トップ3',
  TOP_5: 'トップ5',
  TOP_10: 'トップ10',
  TOP_ALL: '全て',
  REFRESH_BUTTON_TEXT: '更新',
  TENANT: 'テナント',
  BRANCH: '拠点',
  FLOOR: 'フロア',
  SELECT: '選択',
  SELECT_TENANT: 'テナントを選択',
  SELECT_BRANCH: '拠点選択',
  SELECT_FLOOR: 'フロア選択',
  AVERAGE_SCORE: '平均',
  SCORE_TRANSITION: '推移',
  BACKGROUND: 'バックグラウンド',
  BEST_EFFORT: 'ベストエフォート',
  VIDEO: 'ビデオ',
  VOICE: '音声',
  SORT_BY_DEVICE_NAME: '名前順',
  SORT_BY_PERFORMANCE_SCORE_DESC: 'パフォーマンススコア降順',
  SORT_BY_PERFORMANCE_SCORE_ASC: 'パフォーマンススコア昇順',
  RESERVED: '予約時間',
  RESERVED_AND_UNUSED: '使用時間',
  OCCUPIED_9_18: '使用率 (9-18)',
  UNUSED_RESERVATION: '空予約時間',
  RESERVATION_COUNTS: '予約件数',
  EMPTY_BOOKING_RATE: '空予約率',
  MINUTES: '分',
  PAST_ONE_WEEK: '過去１週間',
  PAST_ONE_MONTH: '過去1ヶ月',
  NAME: '名前',
  FREE_BOOKING_TIME: '空予約時間',
  CURRENT_RESERVATION: '現在の予約',
  NEXT_RESERVATION: '次の予約',
  RESERVATION_TIME_BY_ROOM: '部屋別予約時間',
  COLLAPSE_ALL: 'すべて閉じる',
  NETWORK_CLIENT_COUNT_DESCRIPTION: 'アクセスポイントに接続した端末数です',
  PERFORMANCE_SCORE_DESCRIPTION: '各種指標をスコア化し累計した値です',
  PERFORMANCE_SCORE_LEGEND_HEADER: 'スコア',
  WIRELESS_SIGNAL_DESCRIPTION:
    'アクセスポイントのチャネルとSNR (信号対雑音比) です',
  WIRELESS_SIGNAL_LEGEND_HEADER: 'SNR',
  NETWORK_USAGE_DESCRIPTION: 'アクセスポイントと端末間のデータ転送速度です',
  WIRELESS_CHANNEL_UTILIZATION_DESCRIPTION:
    'アクセスポイントが使用するチャネルの干渉度合です',
  WIRELESS_LATENCY_DESCRIPTION: '通信種別毎の遅延時間です',
  AVERAGE: '平均',
  CHANGE: '推移',
  TEMPERATURE: '温度',
  HUMIDITY: '湿度',
  CARBON_DIOXIDE: '二酸化炭素',
  NOISE_LEVEL: '騒音',
  LAST_24_HOUR: '24時間',
  LAST_ONE_WEEK: '1週間',
  LAST_ONE_MONTH: '1ヶ月',
  //CsvExport
  CSV_EXPORT: 'CSVダウンロード',
  OLD_VALUE: '旧',
  NEW_VALUE: '新',
  DATA_CONFIGURATION: 'データ設定',
  TK_OVERVIEW: '高千穂交易の概要',
  // Setting
  TENANT_SETTING: 'テナント',
  ORGANIZATION_SETTING: 'オーガナイゼーション',
  LOCATION_SETTING: '拠点',
  FLOOR_SETTING: 'フロア',
  AREA_SETTING: 'エリア',
  VERKADA_DEVICE_SETTING: 'Verkadaデバイス',
  DEVICE_LOCATION_SETTING: 'デバイスの位置',
  COMPANY_EMPLOYEE_SETTING: '社員',
  EMPLOYEE_TERMINAL_SETTING: '社員端末',
  USER_SETTING: 'ユーザー',
  WORKING_HOUR_SETTING: '就業日時',
  CAMERA_ZONE_SETTING: 'カメラゾーン',
  AIR_QUALITY_SETTING: '環境',
  AUDIT_WRITE_LOG: 'データ変更ログ',
  // End setting

  // Validation
  REQUIRED: '入力してください',
  EMPLOYEE_INFORMATION: '社員情報',
  EMPLOYEE_NUMBER: '社員番号',
  VERKADA_ID: 'Verkada社員ID',
  EMPLOYEE_IMAGE: '画像',
  EMPLOYEE_PHONE_NUMBER: '電話番号1',
  EMPLOYEE_PHONE_NUMBER2: '電話番号2',
  EMPLOYEE_EMAIL: 'メールアドレス',
  EMPLOYEE_TOOL_CHAT: 'チャットツール',
  EMPLOYEE_DEVICE_PC_MAC: 'PC MACアドレス',
  EMPLOYEE_DEVICE_PC_NAME: 'PC 端末名',
  EMPLOYEE_DEVICE_MOBILE_MAC: '携帯 MACアドレス',
  EMPLOYEE_DEVICE_MOBILE_NAME: '携帯 端末名',
  EMPLOYEE_NAME_READING: 'ふりがな',
  EMAIL_FORMAT_ERROR_MESSAGE: 'メールアドレスの形式が正しくありません',
  USER_INFORMATION: 'ユーザー情報',
  PASSWORD: 'パスワード',
  FIRST_NAME: '名前',
  LAST_NAME: '姓',
  PHONE: '電話番号',
  PRIVILEGE: '権限',

  SAVE: '保存',
  CANCEL: 'キャンセル',
  ADD_NEW: '追加',
  DELETE_CONFIRMATION_HEADER: '削除の確認',
  DELETE_CONFIRM_MESSAGE: '削除してよろしいですか？',
  DOWNLOAD: 'ダウンロード',
  RESONABLE_VALUE: '適正値',
  INFO_COPIED_TO_CLIPBOARD: '情報がクリップボードにコピーされました',
  EMPLOYEE_NO_EVENTS: 'イベントなし',
  NO_LOCATION_DATA: '所在データなし',
  DEVICE_LOCATION_CHANGE_HEADER: 'デバイスの位置変更',
  STATUS_NEW: '新規',
  STATUS_MODIFIED: '修正',
  STATUS_DELETED: '削除',
  AREA_CAPACITY: 'エリアの定員',
  MOBILE_DEVICE_TYPE: 'スマートフォン',
  PC_DEVICE_TYPE: 'PC',
  AREA_NAME: 'エリア名',
  COUNTS: '人数',
  CAPACITY_RATE: '占有率',
  NO_CHANGE_TO_BE_SAVED: '保存する変更はありません。',
  EMPLOYEE_ATTENDANCE_RATE: '出社率',
  SIGNAGE_MODE: 'サイネージモード',
  LATEST_ATTENDANCE_RATE: '最新の出社率',
  LOG: '履歴',
  SET: 'セット',
  BY_TIME: '時間別',
  BY_DAY: '日別',
  FROM_DATE: 'から',
  TO_DATE: 'まで',
  TYPE: 'タイプ',
  NO_ZONE: 'ゾーンなし',
  ZONE: 'ゾーン',
  NO_DEVICE: 'デバイスなし',
  MAKE_RESERVATION: '予約する',
  ATTENDANCE_RATE: '出社率%',
  SHOW_CAMERA: 'デバイス表示',
  HIDE_CAMERA: 'デバイス非表示',
  SHOW_HIDE_CAMERA: 'デバイス表示/非表示',
  DEVICE_DISPLAY: 'デバイス表示',
  THRESHOLD_SETTING: '閾値の設定',
  PLEASE_INPUT_VALID_NUMBER: '有効な数値を入力してください',
  HIGH: '高',
  LOW: '低',
  INFO: '情報',
  COMPONENT: 'コンポーネント',
  DISPLAY_TIME: '表示時間',
  CARBON_DIOXIDE_UNIT: 'ppm',
  BUTLR_USERNAME: 'ユーザー名',
  BUTLR_API_KEY: 'パスワード',
  GAROON_USERNAME: 'ログイン名',
  GAROON_API_KEY: 'パスワード',
  GAROON_SUBDOMAIN: 'サブドメイン',
  GOOGLE_API_KEY: 'プライベートキー',
  GOOGLE_USERNAME: 'クライアントEメール',
  WEBEX_API_KEY: 'アクセストークン',
  WEBEX_REFRESH_TOKEN: 'リフレッシュトークン',
  WEBEX_CLIENT_ID: 'クライアントID',
  WEBEX_CLIENT_SECRET: 'クライアントシークレット',
  MICROSOFT_API_KEY: 'クライアントシークレット',
  MICROSOFT_GRAPH_CLIENT_ID: 'クライアントID',
  MICROSOFT_GRAPH_TENANT_ID: 'テナントID',
  API_KEY: 'キー',
  SCHEDULE_TOOL: 'スケジュール管理ツール',
  SHORTENING_MEETING: '終了した会議の自動短縮',
  ROOM_NOTICE: '会議室の短縮・キャンセル通知',
  MEETING_ROOM_ANALYSIS_SETTING: '会議室 利用分析',
  ANALYSIS_TIME_SETTINGS: '分析時間設定',
  ANALYSIS_TIME_SETTINGS_TOOLTIP: 'この時間帯を分母として会議室の予約率・利用率を算出します。',
  MEETING_ROOM_SHORTENING_CANCEL: '会議室の短縮・キャンセル',
  ACTIVE_TIME_SETTINGS: '有効時間設定',
  ACTIVE_TIME_SETTINGS_TOOLTIP: '短縮・キャンセル通知を有効化する時間帯を曜日ごとに設定します。',
  DEVICE_ACTIVE_TIME_SETTINGS_TOOLTIP: '短縮・キャンセル通知を有効化する時間帯を曜日ごとに設定します。「会議室 利用分析」で設定している時間より優先されます。',
  DISABLED: '無効',
  ENABLED: '有効',
  ACTIVE: '稼働',
  SLEEP: 'スリープ',
  START_TIME: '開始',
  END_TIME: '終了',
  MONDAY: '月曜日',
  TUESDAY: '火曜日',
  WEDNESDAY: '水曜日',
  THURSDAY: '木曜日',
  FRIDAY: '金曜日',
  SATURDAY: '土曜日',
  SUNDAY: '日曜日',
  PEOPLE_COUNTS_LEGEND: '占有率の閾値',
  ATTENDANCE_RATE_THRESHOLD: '出社率の閾値',
  NO_DEVICE_AVAILABLE: 'デバイスがありません',
  START_SIGNAGE_MODE: 'サイネージモードを開始',
  PRESS_ESC_TO_EXIT: '終了はescキー',
  LAST_UPDATE_TS: '最終更新日時',
  UPLOAD_MESSAGE: '成功',
  UPLOAD_MESSAGE_SUCCESS: '画像がアップロードされました',
  UPLOAD_ERROR_MESSAGE: 'エラー',
  UPLOAD_EXCEED_MESSAGE: '最大ファイルサイズは1MBです',
  UPLOAD_FAILED_MESSAGE: 'アップロードできないファイルです',
  UPLOAD_MULTIPLE_ERROR_MESSAGE:
    '複数のファイルを一度にアップロードできません。',
  EMPLOYEE_LOCATIONS_LIST: 'リスト',
  EMPLOYEE_LOCATIONS_MAP: 'マップ',
  OTHER_GROUP: '他拠点',
  EMPLOYEE_LOCATION_SELECT: '部門/チームを選択してください',
  BCP: 'BCP',
  EMPLOYEE_BCP_SELECT: 'フロアを選択してください',
  CAPACITY: '定員',
  ADD_MULTIPLE_BRANCH_ERROR_MESSAGE: '拠点を追加できません。',
  ADD_MULTIPLE_FLOOR_ERROR_MESSAGE: 'フロアを追加できません。',
  ADD_MULTIPLE_DEPARTMENT_ERROR_MESSAGE: '部門を追加できません。',
  TENANT_SIGN_ON: 'シングルサインオン',
  TENANT_AUTH_PROVIDER: '認証プロバイダ',
  TENANT_AZURE_TENANT_ID: 'テナントID',
  TENANT_AZURE_CLIENT_ID: 'アプリケーション (クライアント) ID',
  TENANT_AZURE_CLIENT_SECRET: 'クライアントシークレット',
  WEBHOOK_URL: 'Webhook URL',
  TOKEN: 'トークン',
  PEOPLE_COUNT_SELECTED: 'マップに表示する値',
  RATE: '割合',
  THRESHOLD: 'しきい値',
  DEVICE_LOCATION_SHORTENING_METHOD: '早く終わった会議の短縮',
  DEVICE_LOCATION_SHORTENING_THRESHOLD_1: '終了から短縮まで',
  DEVICE_LOCATION_SHORTENING_THRESHOLD_1_REPLY: '終了から通知まで',
  DEVICE_LOCATION_SHORTENING_THRESHOLD_2: '通知から短縮まで',
  DEVICE_LOCATION_CANCEL_METHOD: '開始されない会議のキャンセル',
  DEVICE_LOCATION_CANCEL_THRESHOLD_1: '開始時間からキャンセルまで',
  DEVICE_LOCATION_CANCEL_THRESHOLD_1_REPLY: '開始時間から通知まで',
  DEVICE_LOCATION_CANCEL_THRESHOLD_2: '通知からキャンセルまで',
  DEVICE_LOCATION_SHORTENING_METHOD_DISABLED: '無効',
  DEVICE_LOCATION_SHORTENING_METHOD_SILENCE: '自動で短縮',
  DEVICE_LOCATION_SHORTENING_METHOD_REPLY_SHORTENING: '通知に返信後短縮',
  DEVICE_LOCATION_SHORTENING_METHOD_REPLY_KEEP: '通知に返信後保持',
  DEVICE_LOCATION_CANCEL_METHOD_DISABLED: '無効',
  DEVICE_LOCATION_CANCEL_METHOD_SILENCE: '自動でキャンセル',
  DEVICE_LOCATION_CANCEL_METHOD_REPLY_CANCEL: '通知に返信後キャンセル',
  DEVICE_LOCATION_CANCEL_METHOD_REPLY_KEEP: '通知に返信後保持',
  ARUBA_API_KEY: 'アクセストークン',
  ARUBA_REFRESH_TOKEN: 'リフレッシュトークン',
  ARUBA_CLIENT_SECRET: 'クライアントシークレット',
  ARUBA_CLIENT_ID: 'クライアントID',
  TITLE_NOTICE: 'お知らせ',
  INPUT_NOTICE_ERROR_MESSAGE: 'お知らせは3行以内で入力してください',
  BRANCH_SETTING_HEADER1: '表示順',
  BRANCH_SETTING_HEADER2: '拠点名',
  BRANCH_SETTING_HEADER3: 'Merakiネットワーク/Arubaサイト',
  FLOOR_SETTING_HEADER1: '拠点名',
  FLOOR_SETTING_HEADER2: '表示順',
  FLOOR_SETTING_HEADER3: 'フロア名',
  FLOOR_SETTING_HEADER4: 'Meraki/Arubaフロア',
  FLOOR_SETTING_HEADER5: 'フロアマップ',
  EMPTY: '空き',
  CROWDED: '混雑',

  // Workflows Changelog
  AUDIT_WRITE_LOG_TIMESTAMP: '日時',
  AUDIT_WRITE_LOG_ACTOR: '変更者',
  AUDIT_WRITE_LOG_URL: 'URL',
  AUDIT_WRITE_LOG_CONTENT: '内容',
  AUDIT_WRITE_LOG_HTTP_METHOD: 'HTTPメソッド',

  // New constants for success/error messages
  SAVED_SUCCESSFULLY: '正常に保存されました',
  SAVE_FAILED: '変更に失敗しました',
  EMAIL_ALREADY_EXISTS: 'このメールアドレスは既に存在します',
  UNEXPECTED_ERROR: '予期しないエラーが発生しました',

  // IP Restriction error messages
  IP_RESTRICTION_ERROR_TITLE: 'アクセス拒否',
  IP_RESTRICTION_ERROR_MESSAGE: '許可されていないIPアドレスからのアクセスです。',
  IP_RESTRICTION_SOURCE_IP: '接続元IPアドレス',

  // Authentication Method Settings
  OVERRIDE_LOGIN_METHOD_LABEL: '認証方式のオーバーライド',
  LOGIN_METHODS_LABEL: '認証方式',
  SELECT_LOGIN_METHODS: '認証方式を選択',
  AUTH_METHOD_PASSWORD: 'パスワード',
  AUTH_METHOD_SSO: 'シングルサインオン',
  LOGIN_NOT_ALLOWED: 'ログインが許可されていません',
  AUTH_METHOD_RESTRICTION_DETAIL: 'ご利用の認証方式は管理者によって制限されています。システム管理者にお問い合わせください。',

  // Employee Follow Feature
  FOLLOW: 'フォローする',
  UNFOLLOW: 'フォローを解除する',
  FOLLOWING: 'フォロー中',
  FOLLOW_ALL: '全員フォローする',
  UNFOLLOW_ALL: '全員フォロー解除する',
  FOLLOWED_SUCCESS: 'フォローしました',
  UNFOLLOWED_SUCCESS: 'フォローを解除しました',
  FOLLOWERS_ONLY: 'フォロワー',
  FOLLOW_SECTION_TITLE: 'フォロー',
  NO_FOLLOWED_EMPLOYEES: 'フォロー中のユーザーはいません',
  NO_USER_FOUND: 'ユーザーがいません',
};

const langCode = 'jp';

export const COMMON_TEXT = {
  en: commonTextEn,
  jp: commonTextJp,
  // add more language objects here if needed
}[langCode];
